import React from 'react';
import { Routes,Route, Navigate} from "react-router-dom";
// import { Analytics } from '../components/analytics/Analytics';
import { Anpr } from '../components/anpr';
import { DailyWiseReport } from '../components/DailyWiseReport';
import { Dashboard } from '../components/dashboard';
import { EmployeeAttendanceDetail } from '../components/employeeattendancedetail/EmployeeAttendanceDetail';

import { Fr } from '../components/fr/Fr';
import { FRInOut } from '../components/frInOut/FRInOut';
import { MonthWiseReport } from '../components/MonthWiseReport/DailyWiseReport';
import { Notification } from '../components/notifications';
import { RestrictedArea } from '../components/RestrictedArea/LiveAttendance';
import { Role } from '../components/role/Role'
import { LiveAttendance } from '../components/liveattendance';
import { User } from '../components/user';
import { Vehicle } from '../components/vehicle/Vehicle';
import { VehicleLiveStream } from '../components/vehiclelivestream/VehicleLiveStream';
import { useAuthContext } from '../context/Auth/Create';
import { Login } from '../Login';
import { urlRoutes } from './../helpers';
import  {PrivateRoutes}  from './PrivateRoutes';
import  {PublicRoutes}  from './PublicRoutes';
import { OccupancyPage } from '../components/OccupancyPage';
import { MissingPeople } from '../components/missingpeoples/MissingPeople';
import { LiveStream } from '../components/livestreams/LiveStreams';
import { CheckOut } from '../components/checkouts/CheckOut';
import { GraphForPersonal } from '../components/GraphForPersonal';
import { UserWiseReport } from '../components/UserWiseReport';
import { AttendancePageWithCameraWise } from '../components/AttendancePageWithCameraWise';
import { CombinedData } from '../components/combined-data';





export const Routers = () => {
    const userAuth=useAuthContext();
  
    return (<>
    
        <Routes>
        <Route path="/" element={<Navigate to="/login" replace />}/>
        <Route path="/live-occupancy" element={<OccupancyPage />}/>
        <Route path="/footfall-graph" element={< GraphForPersonal/>}/>
        <Route path="/attendance-page-with-camera/:cameraId" element={<AttendancePageWithCameraWise/>}/>
        <Route element={<PublicRoutes/>}>
        <Route path={urlRoutes.public.login} element={<Login/>}/>
        </Route>
        <Route element={<PrivateRoutes/>}>
        <Route path={urlRoutes.private.dashboard} element={<Dashboard type={userAuth?.user?.isHightAuthority?"company":"building"}/>}/>
        {userAuth?.user?.isHightAuthority && <Route path={urlRoutes.private.buildingOccupancy} element={<Dashboard type={"building"}/>}/>}
        {(userAuth.user && userAuth.user.permissions.includes("Fr")) && <Route path={urlRoutes.private.fr} element={<Fr/>}/>}
        {(userAuth.user && userAuth.user.permissions.includes("Fr In/OUT")) && <Route path={urlRoutes.private.frInOut} element={<FRInOut />}/>}
        {(userAuth.user && userAuth.user.permissions.includes("Fr In/OUT")) && <Route path="/check-outs" element={<CheckOut />}/>}
        {(userAuth.user && userAuth.user.permissions.includes("Day Wise Report")) && <Route path={urlRoutes.private.dailyWiseReport} element={<DailyWiseReport />}/>}
        {(userAuth.user && userAuth.user.permissions.includes("Month Wise Report")) && <Route path={"/user-wise-report"} element={<UserWiseReport/>}/>}
        {(userAuth.user && userAuth.user.permissions.includes("Month Wise Report")) && <Route path={urlRoutes.private.monthWiseReport} element={<MonthWiseReport />}/>}
        {/* {(userAuth.user && userAuth.user.permissions.includes("Anpr")) &&    <Route path={urlRoutes.private.anpr} element={<Anpr />}/>} */}
        {(userAuth.user && userAuth.user.permissions.includes("Restricted Area")) &&    <Route path="/restricted-area" element={<RestrictedArea />}/>}
        {/* {(userAuth.user && userAuth.user.permissions.includes("ANPR")) &&    <Route path={urlRoutes.private.liveAttendance} element={<LiveAttendance />}/>} */}
        {(userAuth.user && userAuth.user.permissions.includes("Live Stream")) &&    <Route path={urlRoutes.private.liveStream} element={<LiveStream />}/>}
        {(userAuth.user && userAuth.user.permissions.includes("Live Stream")) &&    <Route path={urlRoutes.private.liveAttendance} element={<LiveAttendance />}/>}
        {(userAuth.user && userAuth.user.permissions.includes("Fr In/OUT")) && <Route path={urlRoutes.private.employeeAttendanceDetails} element={<EmployeeAttendanceDetail />}/>}
         
        {(userAuth.user && userAuth.user.permissions.includes("Missing People")) && <Route path={urlRoutes.private.missingPeople} element={<MissingPeople/>}/>}
        {(userAuth.user && userAuth.user.permissions.includes("Missing People")) && <Route path={urlRoutes.private.combinedData} element={<CombinedData/>}/>}
        {(userAuth.user && userAuth.user.permissions.includes("Anpr")) && <Route path="/vehicle-area" element={<VehicleLiveStream />}/>}
        {(userAuth.user && userAuth.user.permissions.includes("Role")) &&  <Route path={urlRoutes.private.role} element={<Role/>}/>}
        {(userAuth.user && userAuth.user.permissions.includes("User")) &&   <Route path={urlRoutes.private.user} element={<User/>}/>}
        {(userAuth.user && userAuth.user.permissions.includes("Anpr")) &&    <Route path={urlRoutes.private.vehicle} element={<Vehicle />}/>}
     
        <Route path="notifications" >
        <Route path=":type" element={<Notification/>}>
        </Route>
        </Route>

                    {/* {(userAuth.user && userAuth.user.permissions.includes("MallAnalytics")) && <Route path={urlRoutes.private.analytics} element={<UpdatedAnalytics />}/>}
        {(userAuth.user && userAuth.user.permissions.includes("FoodCourt")) &&   <Route path={urlRoutes.private.foodViseReport} element={<FoodVise/>}/>}
        {(userAuth.user && userAuth.user.permissions.includes("AnchorTeanuts")) &&  <Route path={urlRoutes.private.specialArea} element={<SpecialArea/>}/>}
       
       
         */}
       
       
         
        
       
        
            </Route>
            <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
            
    </>);
}

